/**
 * Enum for DiffType
 *
 * @export
 * @enum {String}
 */
export enum DiffType {
  /**
   * Add
   */
  Add='Add',
  /**
   * Delete
   */
  Delete='Delete',
  /**
   * Update
   */
  Update='Update',
  /**
   * Equal
   */
  Equal='Equal',
  /**
   * Ignore
   */
  Ignore='Ignore'
}